import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {
  Survey,
  SurveyAnswerData,
  SurveyDemographicAnswerData,
} from "../model/SurveyModel";
import { Observable } from "rxjs/Observable";
import { environment } from "../environments/environment";

@Injectable()
export class SurveyService {
  constructor(private http: HttpClient) {}

  // get pesquisa
  public findById(id: number): Observable<any> {
    return this.http.get<Survey[]>(
      environment.apiHost + "/survey/administracao/pesquisa/" + id
    );
  }
  //end

  //user-survey
  public listUserSurveys(userId: number): Observable<any> {
    return this.http.get<Survey[]>(
      environment.apiHost + "/survey/administration/user-survey/users/" + userId
    );
  }

  public startSurvey(userSurveyId: number) {
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    return this.http
      .post(
        environment.apiHost +
          "/survey/administration/user-survey/start/user/" +
          userSurveyId,
        null,
        { headers: headers, responseType: "text" }
      )
      .map((response) => JSON.parse(response));
  }

  public saveSurvey(userSurvey: any) {
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    return this.http
      .put(
        environment.apiHost + "/survey/administration/user-survey/users",
        userSurvey,
        { headers: headers, responseType: "text" }
      )
      .map((response) => response);
  }

  public concludeSurvey(userSurveyId: number) {
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    return this.http
      .post(
        environment.apiHost +
          "/survey/administration/user-survey/conclude/user/" +
          userSurveyId,
        null,
        { headers: headers, responseType: "text" }
      )
      .map((response) => JSON.parse(response));
  }

  // end

  //realize-survey
  public listResultsByUserIdAndAppliedSurvey(
    userId: number,
    appliedSurveyId: number
  ) {
    return this.http.get<any[]>(
      environment.apiHost +
        "/survey/results/user/" +
        userId +
        "/apply-survey/" +
        appliedSurveyId
    );
  }

  public listResultsByExternalUserIdAndAppliedSurvey(
    externalUserId: number,
    appliedSurveyId: number
  ) {
    return this.http.get<any[]>(
      environment.apiHost +
        "/survey/results/user/" +
        externalUserId +
        "/apply-survey/" +
        appliedSurveyId
    );
  }
  // end

  //pergunta
  public getwithoutDiscursiveQuestions(questions: any[]) {
    return questions.filter((question) => {
      return !this.isDiscursive(question);
    });
  }

  public getDiscursiveQuestions(questions: any[]) {
    return questions.filter((question) => {
      return this.isDiscursive(question);
    });
  }

  private isDiscursive = function (question) {
    return question.tipoResposta == 4;
  };
  //end

  public loadDemographicAnswers(
    demographicId: number,
    userId: number
  ): Observable<any> {
    return this.http.get<SurveyDemographicAnswerData>(
      environment.apiHost +
        "/survey/resultadoDemografico/demographic/" +
        demographicId +
        "/user/" +
        userId
    );
  }

  public saveDemographicAnswer(
    answerData: SurveyDemographicAnswerData,
    type: string
  ) {
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    return this.http
      .post(
        environment.apiHost + "/survey/resultadoDemografico/save",
        JSON.stringify(answerData),
        { headers: headers, responseType: "text" }
      )
      .map((response) =>
        this.loadDemographicAnswers(
          answerData.demograficoId,
          answerData.usuarioId
        )
      );
  }

  public saveAnswer(answerData: SurveyAnswerData, type: string) {
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    return this.http
      .post(
        environment.apiHost + "/survey/results/",
        JSON.stringify(answerData),
        { headers: headers, responseType: "text" }
      )
      .map((response) =>
        this.listResultsByUserIdAndAppliedSurvey(
          answerData.usuarioId,
          answerData.aplicaPesquisaId
        )
      );
  }
}



// WEBPACK FOOTER //
// ./src/services/SurveyService.ts